/* 26.09.2026 Pierre: Bereichsleisten (Radio, Startseite) als Schiene mit Abstand
   zum Rand. Dieses Skript setzt nur zwei Zustaende, die Gestaltung liegt im CSS:
   - data-more-start / data-more-end an [data-nav-rail]: links oder rechts geht
     es weiter, dort blendet die Schiene weich aus.
   - data-stuck an der Leiste: sie klebt unter dem Kopf und wird deckend
     (beim Start liegt sie durchsichtig auf der Buehne).
   Ueber Delegation, damit es auch nach einem weichen Seitenwechsel greift. */
(function () {
  'use strict';
  if (window.AsIfNavRail) return;
  var frame = 0;

  function edges(rail) {
    var track = rail.firstElementChild;
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth;
    var x = Math.abs(track.scrollLeft);
    rail.toggleAttribute('data-more-start', max > 2 && x > 2);
    rail.toggleAttribute('data-more-end', max > 2 && x < max - 2);
  }

  function stuck(rail) {
    var nav = rail.parentElement;
    if (!nav) return;
    var top = parseFloat(window.getComputedStyle(nav).top);
    if (isNaN(top)) top = 0;
    var r = nav.getBoundingClientRect();
    nav.toggleAttribute('data-stuck', window.scrollY > 1 && r.top <= top + 1 && r.bottom > 0);
  }

  function update() {
    frame = 0;
    var rails = document.querySelectorAll('[data-nav-rail]');
    for (var i = 0; i < rails.length; i++) { edges(rails[i]); stuck(rails[i]); }
  }

  function schedule() { if (!frame) frame = window.requestAnimationFrame(update); }

  document.addEventListener('scroll', function (event) {
    var t = event.target;
    if (t && t.parentElement && t.parentElement.hasAttribute && t.parentElement.hasAttribute('data-nav-rail')) edges(t.parentElement);
    else schedule();
  }, { capture: true, passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('asif:page', schedule);
  window.addEventListener('load', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
  // Der Favoritenzaehler und spaete Schriften aendern die Breite noch.
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(schedule);
    var watch = function () { document.querySelectorAll('[data-nav-rail] > *, [data-nav-rail] > * > *').forEach(function (el) { ro.observe(el); }); };
    watch();
    document.addEventListener('asif:page', watch);
  }
  // Startseite: Einladung zum Scrollen auf dem Platz des Players. Sichtbar,
  // solange man oben ist; beim Tippen weich zum ersten Kapitel.
  function invite() {
    var el = document.querySelector('[data-home-invite]');
    if (!el) return;
    var hide = window.scrollY > Math.min(160, window.innerHeight * 0.2);
    if (el.hasAttribute('data-hidden') !== hide) el.toggleAttribute('data-hidden', hide);
  }
  var baseUpdate = update;
  update = function () { baseUpdate(); invite(); };
  document.addEventListener('click', function (event) {
    var el = event.target.closest && event.target.closest('[data-home-invite]');
    if (!el) return;
    // Wie ein Tippen auf das Kapitel in der Bereichsleiste: gleicher Sprung,
    // gleiche Abstaende (asif-home.js).
    var link = document.querySelector('[data-home-nav] a[href="' + el.getAttribute('href') + '"]');
    if (!link) return;
    event.preventDefault();
    link.click();
  });
  window.AsIfNavRail = { update: update };
})();
